"use strict";

exports.__esModule = true;
exports.isStaffMemberConnectedToService = exports.isServiceWithVariedPrice = exports.isServiceWithMultiStaff = exports.isServiceWithMultiBusinessLocations = exports.isServiceWithDynamicDuration = exports.isServiceWithAddOns = exports.isServiceVariedPricing = exports.isServicePendingApprovalFlow = exports.isServiceOfferedOnline = exports.isServiceBookOnlineEnabled = exports.isServiceAutoAssignResourceAllowed = exports.isCourseService = exports.isClassService = exports.isAppointmentService = exports.groupServicesByCategories = exports.getServicePricingPlanIds = exports.getServicePrice = exports.getServiceMaxParticipantsPerBooking = exports.getServiceLatestBookingInMinutes = exports.getServiceFixedPrice = exports.getServiceFixedCurrency = exports.getServiceEarliestBookingInMinutes = exports.getServiceCurrency = exports.getServiceCategoryName = exports.getServiceCategoryId = exports.filterNonBusinessLocations = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const isCourseService = service => {
  return service.type === _types.ServiceType.COURSE;
};
exports.isCourseService = isCourseService;
const isAppointmentService = service => {
  return service.type === _types.ServiceType.APPOINTMENT;
};
exports.isAppointmentService = isAppointmentService;
const isClassService = service => {
  return service.type === _types.ServiceType.CLASS;
};
exports.isClassService = isClassService;
const isServiceBookOnlineEnabled = service => {
  var _service$onlineBookin;
  return (_service$onlineBookin = service.onlineBooking) == null ? void 0 : _service$onlineBookin.enabled;
};
exports.isServiceBookOnlineEnabled = isServiceBookOnlineEnabled;
const isServiceAutoAssignResourceAllowed = service => {
  var _service$bookingPolic;
  return (_service$bookingPolic = service.bookingPolicy) == null || (_service$bookingPolic = _service$bookingPolic.resourcesPolicy) == null ? void 0 : _service$bookingPolic.autoAssignAllowed;
};
exports.isServiceAutoAssignResourceAllowed = isServiceAutoAssignResourceAllowed;
const isServicePendingApprovalFlow = service => {
  var _service$onlineBookin2;
  return (_service$onlineBookin2 = service.onlineBooking) == null ? void 0 : _service$onlineBookin2.requireManualApproval;
};
exports.isServicePendingApprovalFlow = isServicePendingApprovalFlow;
const isStaffMemberConnectedToService = (service, staffMemberId) => {
  var _service$staffMemberI;
  return (_service$staffMemberI = service.staffMemberIds) == null ? void 0 : _service$staffMemberI.includes(staffMemberId);
};
exports.isStaffMemberConnectedToService = isStaffMemberConnectedToService;
const getServicePricingPlanIds = service => {
  var _service$payment;
  return (_service$payment = service.payment) == null ? void 0 : _service$payment.pricingPlanIds;
};
exports.getServicePricingPlanIds = getServicePricingPlanIds;
const isServiceVariedPricing = service => {
  var _service$payment2;
  return (_service$payment2 = service.payment) == null ? void 0 : _service$payment2.varied;
};
exports.isServiceVariedPricing = isServiceVariedPricing;
const getServiceFixedPrice = service => {
  var _service$payment3;
  return (_service$payment3 = service.payment) == null || (_service$payment3 = _service$payment3.fixed) == null || (_service$payment3 = _service$payment3.price) == null ? void 0 : _service$payment3.value;
};
exports.getServiceFixedPrice = getServiceFixedPrice;
const getServiceFixedCurrency = service => {
  var _service$payment4;
  return (_service$payment4 = service.payment) == null || (_service$payment4 = _service$payment4.fixed) == null || (_service$payment4 = _service$payment4.price) == null ? void 0 : _service$payment4.currency;
};
exports.getServiceFixedCurrency = getServiceFixedCurrency;
const getServiceMaxParticipantsPerBooking = service => {
  var _service$bookingPolic2;
  return ((_service$bookingPolic2 = service.bookingPolicy) == null || (_service$bookingPolic2 = _service$bookingPolic2.participantsPolicy) == null ? void 0 : _service$bookingPolic2.maxParticipantsPerBooking) || 1;
};
exports.getServiceMaxParticipantsPerBooking = getServiceMaxParticipantsPerBooking;
const getServicePrice = service => {
  var _service$payment5, _service$payment$fixe, _service$payment$vari, _service$payment$cust;
  switch ((_service$payment5 = service.payment) == null ? void 0 : _service$payment5.rateType) {
    case _types.RateType.FIXED:
      return (_service$payment$fixe = service.payment.fixed) == null || (_service$payment$fixe = _service$payment$fixe.price) == null ? void 0 : _service$payment$fixe.value;
    case _types.RateType.VARIED:
      return (_service$payment$vari = service.payment.varied) == null || (_service$payment$vari = _service$payment$vari.defaultPrice) == null ? void 0 : _service$payment$vari.value;
    case _types.RateType.CUSTOM:
      return (_service$payment$cust = service.payment.custom) == null ? void 0 : _service$payment$cust.description;
    case _types.RateType.NO_FEE:
      return '0';
    default:
      return null;
  }
};
exports.getServicePrice = getServicePrice;
const getServiceCurrency = service => {
  var _service$payment6, _service$payment$fixe2, _service$payment$vari2;
  switch ((_service$payment6 = service.payment) == null ? void 0 : _service$payment6.rateType) {
    case _types.RateType.FIXED:
      return (_service$payment$fixe2 = service.payment.fixed) == null || (_service$payment$fixe2 = _service$payment$fixe2.price) == null ? void 0 : _service$payment$fixe2.currency;
    case _types.RateType.VARIED:
      return (_service$payment$vari2 = service.payment.varied) == null || (_service$payment$vari2 = _service$payment$vari2.defaultPrice) == null ? void 0 : _service$payment$vari2.currency;
    default:
      return null;
  }
};
exports.getServiceCurrency = getServiceCurrency;
const getServiceLatestBookingInMinutes = service => {
  var _service$bookingPolic3, _service$bookingPolic4;
  return (_service$bookingPolic3 = service.bookingPolicy) != null && (_service$bookingPolic3 = _service$bookingPolic3.limitLateBookingPolicy) != null && _service$bookingPolic3.enabled ? (_service$bookingPolic4 = service.bookingPolicy) == null || (_service$bookingPolic4 = _service$bookingPolic4.limitLateBookingPolicy) == null ? void 0 : _service$bookingPolic4.latestBookingInMinutes : undefined;
};
exports.getServiceLatestBookingInMinutes = getServiceLatestBookingInMinutes;
const getServiceEarliestBookingInMinutes = service => {
  var _service$bookingPolic5, _service$bookingPolic6;
  return (_service$bookingPolic5 = service.bookingPolicy) != null && (_service$bookingPolic5 = _service$bookingPolic5.limitEarlyBookingPolicy) != null && _service$bookingPolic5.enabled ? (_service$bookingPolic6 = service.bookingPolicy) == null || (_service$bookingPolic6 = _service$bookingPolic6.limitEarlyBookingPolicy) == null ? void 0 : _service$bookingPolic6.earliestBookingInMinutes : undefined;
};
exports.getServiceEarliestBookingInMinutes = getServiceEarliestBookingInMinutes;
const getServiceCategoryId = service => {
  var _service$category;
  return (_service$category = service.category) == null ? void 0 : _service$category.id;
};
exports.getServiceCategoryId = getServiceCategoryId;
const getServiceCategoryName = service => {
  var _service$category2;
  return (_service$category2 = service.category) == null ? void 0 : _service$category2.name;
};
exports.getServiceCategoryName = getServiceCategoryName;
const isServiceOfferedOnline = service => {
  var _service$conferencing;
  return (_service$conferencing = service.conferencing) == null ? void 0 : _service$conferencing.enabled;
};
exports.isServiceOfferedOnline = isServiceOfferedOnline;
const isServiceWithDynamicDuration = service => {
  var _service$schedule;
  const durations = ((_service$schedule = service.schedule) == null || (_service$schedule = _service$schedule.availabilityConstraints) == null ? void 0 : _service$schedule.durations) || [];
  return service.type === _types.ServiceType.APPOINTMENT && durations.length > 1;
};
exports.isServiceWithDynamicDuration = isServiceWithDynamicDuration;
const isServiceWithAddOns = service => {
  var _service$addOnGroups;
  return !!((_service$addOnGroups = service.addOnGroups) != null && _service$addOnGroups.some(group => {
    var _group$addOnIds;
    return (_group$addOnIds = group.addOnIds) == null ? void 0 : _group$addOnIds.length;
  }));
};
exports.isServiceWithAddOns = isServiceWithAddOns;
const groupServicesByCategories = services => {
  const categoryMap = new Map();
  services.forEach(service => {
    if (!service.category) {
      return;
    }
    const categoryId = service.category.id;
    const groupedServices = categoryMap.get(categoryId);
    groupedServices ? groupedServices.push(service) : categoryMap.set(categoryId, [service]);
  });
  return categoryMap;
};
exports.groupServicesByCategories = groupServicesByCategories;
const isServiceWithMultiStaff = service => {
  var _service$staffMembers;
  return ((service == null || (_service$staffMembers = service.staffMembers) == null ? void 0 : _service$staffMembers.length) || 0) > 1;
};
exports.isServiceWithMultiStaff = isServiceWithMultiStaff;
const filterNonBusinessLocations = locations => locations.filter(location => location.type === _types.LocationType.BUSINESS);
exports.filterNonBusinessLocations = filterNonBusinessLocations;
const isServiceWithMultiBusinessLocations = service => {
  const businessLocations = filterNonBusinessLocations((service == null ? void 0 : service.locations) || []);
  return businessLocations.length > 1;
};
exports.isServiceWithMultiBusinessLocations = isServiceWithMultiBusinessLocations;
const isServiceWithVariedPrice = service => {
  var _service$payment7;
  return (service == null || (_service$payment7 = service.payment) == null ? void 0 : _service$payment7.rateType) === _types.RateType.VARIED;
};
exports.isServiceWithVariedPrice = isServiceWithVariedPrice;
//# sourceMappingURL=service.js.map